import { render, staticRenderFns } from "./EventTotal.vue?vue&type=template&id=5e705ca0&scoped=true&"
import script from "./EventTotal.vue?vue&type=script&lang=js&"
export * from "./EventTotal.vue?vue&type=script&lang=js&"
import style0 from "./EventTotal.vue?vue&type=style&index=0&id=5e705ca0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e705ca0",
  null
  
)

export default component.exports